import React, { useState } from 'react';
import { MdLogout, MdSettings, MdList } from 'react-icons/md';
import { RiUser3Fill, RiUserAddFill, RiDatabase2Fill } from 'react-icons/ri';
import { NavLink, useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import Divider from '@mui/material/Divider';

import { useAuth } from '../context/auth';
import { useNotification } from '../context/notification';
import { logout } from '../api/admin';
import logo from '../images/logo.png';
import config from '../../package.json';

function Header() {
  const auth = useAuth();
  const navigate = useNavigate();
  const { addNotification } = useNotification();
  const queryClient = useQueryClient();
  const [anchorEl, setAnchorEl] = useState(null);

  const { mutate } = useMutation('user', logout, {
    onSuccess: (res) => {
      auth.logout();
      queryClient.invalidateQueries('user');
      navigate('/login');
      addNotification({ message: res.message });
    },
  });

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div className="flex w-full bg-zinc-900 justify-end px-4 header items-center relative">
      {/* <NavLink className="hover:text-blue-400 duration-300 space-x-2" to="/">
        <span>TICKER</span>
        <span>v{config.version}</span>
            </NavLink> */}
      <img src={logo} alt="logo luxiris" className="w-20 absolute translate-x-1/2 translate-y-1/2 bottom-1/2 right-1/2" />
      {auth?.user ? (
        <div className="flex items-center space-x-2 menu-header">
          <NavLink className="hover:text-blue-400 duration-300 space-x-2 mr-20" to="/">
            <span>TICKER</span>
            <span>v{config.version}</span>
          </NavLink>
          {auth?.user?.rights?.admin || auth?.user?.rights?.theme ? (
            <button type="button" onClick={(e) => setAnchorEl(e.currentTarget)}>
              <MdSettings className="focus" size={18} />
            </button>
          ) : null}
          <span className='mr-20'>{auth?.user?.username}</span>
          <button onClick={() => mutate()} type="button" className="danger space-x-2 flex items-center">
            <MdLogout size={18} />
          </button>
        </div>
      ) : (
        <NavLink to="/login">Login</NavLink>
      )}
      <Popover
        id={id}
        className="adminMenu"
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <List disablePadding className="bg-zinc-700">
          {auth?.user?.rights?.admin ? (
            <>
              <NavLink onClick={() => setAnchorEl(null)} to="/admin/database">
                <ListItemButton className="space-x-2">
                  <RiDatabase2Fill /> <span>Database</span>
                </ListItemButton>
              </NavLink>
              <Divider />
              <NavLink onClick={() => setAnchorEl(null)} to="/admin/users">
                <ListItemButton className="space-x-2">
                  <RiUser3Fill /> <span>Utilisateurs</span>
                </ListItemButton>
              </NavLink>
              <NavLink onClick={() => setAnchorEl(null)} to="/admin/signup">
                <ListItemButton className="space-x-2">
                  <RiUserAddFill /> <span>Créer Utilisateur</span>
                </ListItemButton>
              </NavLink>
            </>
          ) : null}
          {auth?.user?.rights?.admin || auth?.user?.rights?.theme ? (
            <NavLink onClick={() => setAnchorEl(null)} to="/admin/theme">
              <ListItemButton className="space-x-2">
                <MdList size={19} /> <span>Thèmes</span>
              </ListItemButton>
            </NavLink>
          ) : null}
        </List>
      </Popover>
    </div>
  );
}

export default Header;
